export default __webpack_public_path__ + "static/media/sector-callCenter.780f4827.png";